import { jsx as _jsx } from "react/jsx-runtime";
import { FALLBACK_PHOTOS } from '../brand/fallback-photos';
import { cn } from '../lib/cn';
const GROUND = {
    amande: 'bg-cream',
    navy: 'bg-surface-ink',
};
const RATIO = {
    '16/10': 'aspect-[16/10]',
    '16/9': 'aspect-[16/9]',
    '1/1': 'aspect-square',
};
/** FNV-1a, 32-bit. Small, dependency-free, and stable across runtimes. */
export function hashSeed(seed) {
    let hash = 0x811c9dc5;
    for (let i = 0; i < seed.length; i += 1) {
        hash ^= seed.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
}
export function fallbackFor(seed, pool = FALLBACK_PHOTOS) {
    // The upper bits, as before: the photo an item wore under WS3 is the photo
    // it keeps, so the de-shaping changed the frame and not the picture.
    return pool[(hashSeed(seed) >>> 8) % pool.length];
}
export function PhotoCover({ src, alt, seed, tone = 'amande', ratio = '16/10', fallbackSrcs = FALLBACK_PHOTOS, fit = 'cover', className, }) {
    const href = src ?? fallbackFor(seed, fallbackSrcs);
    const decorative = !alt;
    return (_jsx("span", { className: cn('block h-full w-full overflow-hidden', RATIO[ratio], GROUND[tone], className), "data-cover": src ? 'own' : 'fallback', "data-fit": fit, ...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': alt }), children: _jsx("img", { src: href, alt: "", className: cn('block h-full w-full', fit === 'contain' ? 'object-contain' : 'object-cover'), loading: "lazy", decoding: "async" }) }));
}
//# sourceMappingURL=photo-cover.js.map